import normalizeImportValue from "../normalizeImportValue";

export default function processDeduplication({ normalizedProfiles, existingProfiles, getFieldByKey }) {
  const getProfileKey = (profile) => `${profile.username?.toLowerCase()}:${profile.platform?.toLowerCase()}`;

  const splitPartnerData = (profile) => {
    const excludedFields = ["created_at", "id"];
    const influencerData = {};
    const extraFields = {};

    Object.entries(profile).forEach(([key, value]) => {
      if (excludedFields.includes(key)) return;

      const field = getFieldByKey({ columnKey: key });
      const table = field?.db_table;
      const normalizedValue = normalizeImportValue({ key, value, type: field?.type });

      if (normalizedValue === null) return;
      if (table === "influencers" || key === "link") {
        influencerData[key] = normalizedValue;
      } else if (table) {
        extraFields[key] = normalizedValue;
      }
    });

    return { influencerData, extraFields };
  };

  const existingMap = new Map();
  (existingProfiles || []).forEach((p) => {
    const key = getProfileKey(p);
    const existing = existingMap.get(key) || [];
    existingMap.set(key, [...existing, p]);
  });

  const seenKeys = new Set();
  const profilesToInsert = [];
  const skippedProfiles = [];
  const additionalDataMap = new Map();

  normalizedProfiles.forEach((profile) => {
    const profileKey = getProfileKey(profile);
    if (seenKeys.has(profileKey)) return;

    seenKeys.add(profileKey);
    const { influencerData, extraFields } = splitPartnerData(profile);

    const existingDuplicates = existingMap.get(profileKey);
    if (existingDuplicates) {
      skippedProfiles.push(influencerData);
    } else {
      profilesToInsert.push(influencerData);
      if (Object.keys(extraFields).length) additionalDataMap.set(profileKey, extraFields);
    }
  });

  return { profilesToInsert, skippedProfiles, additionalDataMap, getProfileKey };
}
